import React from 'react';

import Home from './Home';

import AppRootRedirect from './AppRootRedirect';

import { isAppHost } from '../utils/siteHost';



const RootRoute = () => (isAppHost() ? <AppRootRedirect /> : <Home />);



export default RootRoute;

